<template>
    <IntegrationStoreSettingsLayout @save="save" @cancel="cancel">
        <div class="form-group">
            <label class="font-weight-bold">Warehouses</label>

            <div v-for="(warehouseName, warehouseId) in formData.available_warehouse_ids">
                <div class="checkbox-inline">
                    <label class="checkbox">
                        <input type="checkbox"
                               v-model="selectedWarehouses[warehouseId]"
                        >
                        <span></span>[{{ warehouseId }}] {{ warehouseName }}</label>
                </div>
            </div>

            <span class="form-text text-muted">
                {{ __('integrations.select_warehouse') }}
            </span>
        </div>
    </IntegrationStoreSettingsLayout>
</template>

<script>
import Errors from "@components/Errors.vue";
import IntegrationStoreSettingsLayout from "@layouts/IntegrationStoreSettingsLayout.vue";
import IntegrationStoreConfigMixin from "@mixins/IntegrationStoreConfigMixin";

export default {
    components: {IntegrationStoreSettingsLayout, Errors},

    mixins: [IntegrationStoreConfigMixin],

    data() {
        return {
            selectedWarehouses: {},
            storeConfig: {}
        }
    },

    methods: {
        getSelectedWarehouseIds() {
            let warehouseIds = [];
            for (let warehouseId in this.selectedWarehouses) {
                if (this.selectedWarehouses[warehouseId]) {
                    warehouseIds.push(warehouseId);
                }
            }
            return warehouseIds;
        },

        save() {
            this.config.plenty_warehouse_ids = this.getSelectedWarehouseIds();
            this.saveAndContinue()
        },

        cancel(event) {
            this.config.plenty_warehouse_ids = this.getSelectedWarehouseIds();
            this.preventLeavingWithUnsavedChanges(event);
        }
    },

    mounted() {
        for (let warehouseId of this.formData.plenty_warehouse_ids) {
            this.selectedWarehouses[warehouseId] = true;
        }
    }
}
</script>
